import axios from "axios";
import { API } from "./apiClient";

const http = axios.create({ baseURL: API, withCredentials: true });

export const DESTINATION_PROPOSAL_TYPES = [
  { value: "BIKE_PARK", label: "Bike park" },
  { value: "TRAIL_CENTER", label: "Trail center" },
  { value: "RIDING_AREA", label: "Riding area" },
  { value: "STANDALONE_TRAIL", label: "Standalone trail" },
  { value: "OTHER", label: "Other" },
];

export const emptyDestinationProposal = () => ({
  name: "",
  location: "",
  primaryType: "BIKE_PARK",
  website: "",
  summary: "",
  accessContext: "",
  description: "",
  openingHours: "",
  season: "",
  parking: "",
  trails: [],
  sourceUrl: "",
  sourceNote: "",
  contactName: "",
  contactEmail: "",
});

const clean = (value) => value?.trim() || null;

export const normalizeDestinationProposal = (form) => ({
  name: form.name.trim(),
  location: form.location.trim(),
  primary_type: form.primaryType,
  website: clean(form.website),
  summary: clean(form.summary),
  access_context: clean(form.accessContext),
  description: clean(form.description),
  opening_hours: clean(form.openingHours),
  season: clean(form.season),
  parking: clean(form.parking),
  trails: (form.trails || []).map((trail) => ({
    name: String(trail.name || "").trim(),
    difficulty: trail.difficulty || "UNKNOWN",
    length_km: trail.lengthM === "" || trail.lengthM == null ? null : Number(trail.lengthM) / 1000,
    elevation_gain_m: trail.elevationGainM === "" || trail.elevationGainM == null ? null : Number(trail.elevationGainM),
    elevation_loss_m: trail.elevationLossM === "" || trail.elevationLossM == null ? null : Number(trail.elevationLossM),
    trail_type: clean(trail.trailType === "__OTHER__" ? trail.trailTypeOther : trail.trailType),
    riding_style: clean(trail.ridingStyle === "__OTHER__" ? trail.ridingStyleOther : trail.ridingStyle),
    surface: clean(trail.surface === "__OTHER__" ? trail.surfaceOther : trail.surface),
    description: clean(trail.description),
  })),
  source_url: clean(form.sourceUrl),
  source_note: clean(form.sourceNote),
  contact_name: clean(form.contactName),
  contact_email: clean(form.contactEmail),
});

export const validateDestinationProposal = (input) => {
  if (!input.name) return "Destination name is required";
  if (!input.location) return "Location is required";
  if (!input.primary_type) return "Destination type is required";
  for (const [index, trail] of (input.trails || []).entries()) {
    if (!trail.name) return `Trail ${index + 1} needs a name`;
    for (const [label, value] of [
      ["Length", trail.length_km],
      ["Elevation gain", trail.elevation_gain_m],
      ["Elevation loss", trail.elevation_loss_m],
    ]) {
      if (value != null && (!Number.isFinite(value) || value < 0)) return `Trail ${index + 1} ${label.toLowerCase()} must be a positive number`;
    }
  }
  return null;
};

export async function submitDestinationProposal(input) {
  const response = await http.post("", {
    query: `mutation SubmitDestinationProposal($input: DestinationProposalInput!) {
      submitDestinationProposal(input: $input) { id status submitted_at }
    }`,
    variables: { input },
  });
  if (response.data.errors?.length) throw new Error(response.data.errors[0].message);
  return response.data.data.submitDestinationProposal;
}
